import React from 'react';
import type { ProductId } from '../../types/snak';
const INK = '#01332b';
const METAL = '#CBD8D4';
interface ProductVisualProps {
  product: ProductId;
  className?: string;
}

/**
 * Credible, premium rendering of a composite syringe.
 * Personality is carried by the supporting accents, never by the product itself.
 */
export function ProductVisual({
  product,
  className = ''
}: ProductVisualProps) {
  const label = product === 'supreme' ? '#0F62AB' : product === 'easyMatch' ? '#6E4A9E' : '#05A63A';
  const wordmark = product === 'supreme' ? 'SUPREME' : product === 'easyMatch' ? 'EASY MATCH' : 'ONE BULK FILL';
  return <svg viewBox="0 0 170 268" className={className} role="img" aria-label={`Filtek ${wordmark.toLowerCase()} composite syringe`} data-id="element-82" data-mp="24vjkkmd4a8b3">
      <ellipse cx="85" cy="256" rx="42" ry="6" fill={INK} opacity="0.14" data-id="element-83" data-mp="1vutr3pbbwu0j" />

      {/* supporting accents — subtle family-role cues */}
      {product === 'supreme' && <g stroke="#0F62AB" strokeWidth="1.4" opacity="0.6" data-id="element-84" data-mp="1qxlavu9qr01x">
          <path d="M22 96 h16 M22 116 h10 M22 136 h16 M22 156 h10" strokeLinecap="round" data-id="element-85" data-mp="1m9h44lg39rrc" />
          <circle cx="138" cy="120" r="14" fill="none" data-id="element-86" data-mp="1r1qzwi3vxm1j" />
          <path d="M138 102 v36 M120 120 h36" strokeLinecap="round" data-id="element-87" data-mp="1d9kgmn5fqyxv" />
        </g>}
      {product === 'easyMatch' && <g data-id="element-88" data-mp="1hae9luxqj3xm">
          <circle cx="28" cy="104" r="9" fill="#EBD9BE" data-id="element-89" data-mp="1hbz27f0hocsu" />
          <circle cx="28" cy="126" r="9" fill="#E0C9A6" data-id="element-90" data-mp="250qlfgw3pkth" />
          <circle cx="28" cy="148" r="9" fill="#D3B88E" data-id="element-91" data-mp="2519xwi2zfh04" />
          <path d="M140 100 q12 26 0 52" fill="none" stroke="#6E4A9E" strokeWidth="1.6" strokeDasharray="4 5" strokeLinecap="round" data-id="element-92" data-mp="2a0d07urkv94e" />
        </g>}
      {product === 'oneBulkFill' && <g stroke="#05A63A" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-93" data-mp="kkwruhlh9rfk">
          <path d="M26 100 l10 10 -10 10" data-id="element-94" data-mp="kmzsdvk9b2yj" />
          <path d="M26 124 l10 10 -10 10" data-id="element-95" data-mp="pkj8z24ffrtn" />
          <path d="M140 98 v56" strokeWidth="1.4" data-id="element-96" data-mp="plb286ajxdgr" />
          <path d="M134 98 h12 M134 154 h12" strokeWidth="1.4" data-id="element-97" data-mp="2r9p0ninnabp5" />
        </g>}

      {/* nozzle */}
      <path d="M78 12 h14 l3 22 h-20 z" fill={METAL} data-id="element-98" data-mp="2m9svvh74ig8j" />
      <rect x="68" y="32" width="34" height="11" rx="5" fill={label} data-id="element-99" data-mp="2mc5l8ff7nsvm" />

      {/* barrel */}
      <rect x="62" y="42" width="46" height="152" rx="16" fill="#FFFFFF" stroke={INK} strokeWidth="2.2" data-id="element-100" data-mp="2hh9k8przxv6d" />
      <rect x="62" y="80" width="46" height="74" fill={label} data-id="element-101" data-mp="28jh6hq1xavl3" />
      <rect x="70" y="58" width="12" height="14" rx="6" fill={INK} opacity="0.08" data-id="element-102" data-mp="23j1q0pmch7yw" />

      <text transform="rotate(-90 85 117)" x="85" y="117" textAnchor="middle" fill="#FFFFFF" fontFamily="Inter, sans-serif" fontSize="13" fontWeight="600" letterSpacing="1.5" data-id="element-103" data-mp="1yk8cix725gyq">
        FILTEK
      </text>
      <text transform="rotate(-90 100 117)" x="100" y="117" textAnchor="middle" fill="#FFFFFF" fontFamily="Inter, sans-serif" fontSize="6.5" letterSpacing="1.6" opacity="0.9" data-id="element-104" data-mp="3sw6kywxjm8tk">
        {wordmark}
      </text>

      {/* plunger */}
      <rect x="52" y="194" width="66" height="9" rx="4.5" fill={INK} data-id="element-105" data-mp="1key8rag4yl21" />
      <rect x="77" y="203" width="16" height="32" rx="7" fill={METAL} data-id="element-106" data-mp="1kfrhui2khmnc" />
      <rect x="62" y="233" width="46" height="11" rx="5.5" fill={INK} data-id="element-107" data-mp="1of9sml0ochcg" />
    </svg>;
}